import React from 'react';
import img from './img/AboutFinal.jpg';

const Aboutus = () => {

  return (
    <>
    <div className="container-fluid py-5 smooth " >
      <div className="container">
        <div className="row g-5 align-items-center">
          <div className="col-lg-6 wow fadeIn" data-wow-delay="0.1s">
            <div className="about-img">
              <img className="img-fluid" src={img} loading="lazy" alt="About Us" />
            </div>
          </div>
          <div className="col-lg-6 wow fadeIn animate__animated animate__slideInRight" data-wow-delay="0.5s">
            <div className="btn  px-3 mb-3 under">About Us</div>
            <h1 className="mb-4">We are committed to making the digital world safer for your businesses</h1>
            <p className="mb-4">
            We at Cyber Arcadia, deliver comprehensive services covering the complete gamut of Cyber Security. Our mission is to provide top-notch cybersecurity solutions, empowering our clients to navigate the cyber security challenges confidently.
            </p>
            <p className="mb-4">
            We offer a wide range of  cybersecurity services i.e.  
            </p>
            <div className="row g-3">
              <div className="col-sm-6">
                <h6 className="mb-3"><i className="fa fa-check text-primary me-2"></i>Transformation and implementation services</h6>
                <h6 className="mb-0"><i className="fa fa-check text-primary me-2"></i>Managed security services</h6>
              </div>
              <div className="col-sm-6">
                <h6 className="mb-3"><i className="fa fa-check text-primary me-2"></i>Security Assurance</h6>
                <h6 className="mb-0"><i className="fa fa-check text-primary me-2"></i>Regulatory Compliance</h6>
              </div>
            </div>
            <div className="d-flex align-items-center mt-4">
              <a className="btn btn-outline-primary btn-square me-3" target='blank' href="https://www.instagram.com/cyber_arcadia_academy?igsh=anVhb21nZjhiN2x6&utm_source=qr"><i className="fab fa-instagram"></i></a>
              <a className="btn btn-outline-primary btn-square" target='blank' href="https://www.linkedin.com/company/cyber-arcadia/about/?viewAsMember=true"><i className="fab fa-linkedin-in"></i></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  )
}

export default Aboutus
